import axios, { AxiosRequestHeaders, Method } from 'axios'

const API_BASE_URL = process.env.REACT_APP_BASE_URL_API || 'https://atcreate-api.azurewebsites.net/api'
// 'http://localhost:7071/api'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export async function apiRequestPublic(method: Method, url: string, data?: any): Promise<any> {
  const response = await axios({
    url: API_BASE_URL + url,
    method,
    data,
  })

  return response.data
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export async function apiRequestProtected(method: Method, url: string, data?: any): Promise<any> {
  const token = localStorage.getItem('token')

  const authHeaders: AxiosRequestHeaders = {
    'Content-Type': 'application/json',
  }

  if (token) {
    authHeaders.Authorization = `Bearer ${token}`

    const response = await axios({
      url: API_BASE_URL + url,
      method,
      data,
      headers: authHeaders,
    })

    return response.data
  } else {
    throw new Error('apiRequestProtected() - invalid token')
  }
}
